import grapesjs from 'drapcode-builder';
import loadBlocks from './blocks';
import loadComponents from './components';
import { paginationPageSize } from './consts';
export default grapesjs.plugins.add('gjs-pagination-page-size', (editor, opts = {}) => {
  let c = opts;
  let defaults = {
    blocks: [paginationPageSize],
    defaultStyle: true,
    pfx: 'paginationPageSize',
    label: 'Pagination Page Size',
    category: 'CMS',
  };
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  loadComponents(editor, c);
  loadBlocks(editor, c);
});
